export default () => ({
  mode: {
    isModalNew: true,
    isModalPush: true
  },
  sortable: {
    field: 'entryDate',
    order: 'desc'
  },
  store: {
    get: {
      url: 'PaymentLogs/GetAllDynamic',
      selected: [
        'id,paymentID,employeeID,entryDate,description',
        'payment.invoiceNumber as invoiceNumber', 'employee.name as employeeName'
      ].join(',')
    }
  },
  header: {
    controls: {
      isVisible: true,
      export: {
        json: {
          current: {
            isVisible: false
          },
          all: {
            isVisible: false
          }
        }
      },
      addNew: {
        isVisible: false
      }
    }
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('invoice-number')}",
      field: 'invoiceNumber',
      sortable: {
        custom: 'payment.invoiceNumber'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('employee')}",
      field: 'employeeName',
      sortable: {
        custom: 'employee.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('entry-date')}",
      field: 'entryDate',
      template: 'date',
      editor: {
        type: 'date'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: "${root.L10n('description')}",
      field: 'description'
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          valueTemplate: ({ value }) =>
            [
              'payment.invoiceNumber', 'employee.name', 'description'
            ]
              .map((field) => `${field}.contains("${value}")`).join(' || '),
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('search')}",
          styles: {
            minWidth: '17rem'
          }
        }
      },
      {
        'type': 'select',
        'field': 'employeeID',
        // eslint-disable-next-line no-template-curly-in-string
        'label': "${root.L10n('employee')}",
        'options': {
          'dataSource': 'Employees/GetAllDynamic?select=id,name as title&filter=isActive==true',
          // eslint-disable-next-line no-template-curly-in-string
          'placeholder': "${root.L10n('all')}",
          'styles': {
            'minWidth': '14rem'
          }
        }
      }
    ]
  },
  rowControls: {
    right: {
      classes: 'controls-inline',
      controls: [
        {
          type: 'custom',
          // eslint-disable-next-line no-template-curly-in-string
          title: "${root.L10n('go-to-payment')}"
        }
      ]
    }
  }
})
